import { Col, Input, InputGroup, InputGroupText, Row } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { Submit } from "../../../../Constant";
import { CardDetailProp } from "../../../../Type/FormLayoutType";

export const CardDetails = ({ cartInfoForm, getUserData }: CardDetailProp) => {
  const { recipientUserName, userName } = cartInfoForm;

  return (
    <Col xxl="6" className="mb-3">
      <Row>
        <Col xs="12">
          <InputGroup className="mb-3">
            <Input type="text" placeholder="Recipient's username" name="recipientUserName" value={recipientUserName} onChange={getUserData} />
            <Btn outline color="secondary">{Submit}</Btn>
          </InputGroup>
        </Col>
        <Col xs="12">
          <InputGroup>
            <InputGroupText>@</InputGroupText>
            <Input type="text" placeholder="Username" name="userName" value={userName} onChange={getUserData} />
          </InputGroup>
        </Col>
      </Row>
    </Col>
  );
};
